<template>
  <!--<div class="page-index">-->
  <div>
    <div class="breadcrumb-wrapper" v-if="serviceShow">
      <div class="h-breadcrumb">
        <span v-for="(item, i) in cumbList" :key="i">
          <a
            v-if="item.fullpath && item.fullpath != undefined"
            class="h-breadcrumb-item-link"
            :href="i < cumbList.length - 1 ? item.path : ''"
            >{{ item.name }}</a
          >
          <router-link
            v-if="
              (!item.fullpath || item.fullpath == undefined) &&
                i < cumbList.length - 1
            "
            class="h-breadcrumb-item-link"
            :to="item.path"
            >{{ item.name }}</router-link
          >
          <span
            v-if="i == cumbList.length - 1"
            class="h-breadcrumb-item-link"
            >{{ item.name }}</span
          >
          <span class="h-breadcrumb-item-separator">/</span>
        </span>
      </div>
    </div>
    <!-- <div class="breadcrumb-wrapper">
      <h-breadcrumb>
        <h-breadcrumb-item v-for="(item, i) in cumbList" :href="i < cumbList.length - 1 ? item.path : ''" v-if="item.name">{{ item.name }}</h-breadcrumb-item>
      </h-breadcrumb>
    </div> -->
  </div>
  <!--</div>-->
</template>
<script>
//import HPanel from '@/components/HPanel'
import store from "@/store";
import { mapGetters } from "vuex";
import { detail } from "@/api/service.js";
export default {
  name: "marketrBar",
  data() {
    return {
      //user:store.getters.user,
      login: "",
      nav: 3,
      nickName: "",
      cumbList: [],
      searchText: "",
      serviceUrl: [
        {
          name: "LIGHT云",
          path: "/",
          fullpath: `https://${window.location.host}`
        },
        { name: "云市场", path: `/serviceProduct` }
      ],
      serviceShow: this.$route.name == "虚商" ? false : true
    };
  },
  // props:{
  //     nickName:'',
  //     login:'',
  // },
  watch: {
    $route(to, from) {
      this.cumbList = [...this.serviceUrl];
      if (this.$route.params.id) {
        detail(this.$route.params.id).then(res => {
          let obj = {};
          obj.name = res.service_name;
          this.cumbList.push(obj);
        });
      }
    },
    user() {}
    //  'computeName.user'(){
    //    if(this.$store.state.user.user){
    //      let name = this.$store.state.user.user.hideNickName,
    //      loginStatus = this.$store.state.user.user.hsid?true:false;
    //       this.nickName = name;
    //       this.login = loginStatus;
    //        ;
    //       this.$forceUpdate();
    //       console.log('变了'+this.nickName + this.login)
    //    }

    //  }
  },
  computed: {
    ...mapGetters(["user"])
  },
  created() {
    // let nikeName = store.getters.user.nike_name;
    // if(nikeName){
    //     //nikeName=$.trim(r.nikeName);
    //     if(/^1[3|4|5|7|8]\d{9}$/.test(nikeName) || /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(nikeName)){
    //       let str1 = nikeName.substring(0,3);
    //       let str2 = nikeName.substring(nikeName.length-4,nikeName.length);
    //       nikeName=str1+"****"+str2;
    //     }
    // }else{
    //     nikeName=store.getters.user.hsid;
    //     if(nikeName){
    //       let str1 = nikeName.substring(0,3);
    //       let str2 = nikeName.substring(nikeName.length-4,nikeName.length);
    //       nikeName=str1+"****"+str2;
    //     }
    // }
    // this.nickName = nikeName;
  },
  mounted() {
    this.cumbList = [...this.serviceUrl];
    if (this.$route.params.id) {
      detail(this.$route.params.id).then(res => {
        let obj = {};
        obj.name = res.service_name;
        this.cumbList.push(obj);
      });
    }
  },
  methods: {
    goComponents() {
      // window.location.href = "/openplat-front/#/serviceProduct"
      window.open("/openplat-front/serviceProduct", "_blank");
    },
    goLogin() {
      //this.$router.push({ path: '/login' })
      localStorage.setItem("backUrl", window.location.href);
      this.$goLoginUrl();
    },
    goConsole() {
      //if(this.login){
      // window.location.href = "/console/services.html"
      // }else{
      //   window.location.href = window.LOCAL_CONFIG.userCenter + '/login' +
      //   '?service=' +window.location.href.split('#')[0].split("?")[0];
      // }
      // window.location.href = "/openplat-front/#/console"
      window.open("/openplat-front/console", "_blank");
    },
    goRegister() {
      this.$registerFun();
    },
    //转到搜索页
    goSearch() {
      // window.location.href =
      //   "/result.html?content=" + encodeURIComponent(this.searchText)
      window.open(
        "/openplat-front/searchResult?content=" + encodeURIComponent(this.searchText),
        "_blank"
      );
    }
  }
};
</script>
<style lang="scss" scoped>
// .cursor-pointer{
//   cursor:pointer;
// }
.page-index {
  min-height: calc(100vh - 60px);
  background: #f3f4f5;
}
.hs-topbar {
  /**max-width:1200px;**/
  margin: 0 auto;
  background: #fff;
}
.hs-topbar-header {
  height: 70px;
  line-height: 70px;
  width: 1200px;
  margin: 0 auto;
  display: table;
  word-spacing: -1em;
}
.header-item {
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
}
.logo-wrapper {
  height: 100%;
}
.logo-wrapper img {
  width: 125px;
  height: 36px;
  vertical-align: middle;
}
.nav-text-split {
  padding: 0 10px 0 10px;
  /**height:14px;**/
}
.nav-text {
  color: #333;
  font-size: 16px;
  padding-top: 1px;
  word-spacing: 0em;
}
.search-wrapper {
  margin: 15px 0 0 61px;
  height: 35px;
  position: relative;
  .search-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    background: url(../../../assets/search-icon.png) center center no-repeat;
    left: 13px;
    top: 10px;
  }
}
.search-wrapper input {
  width: 380px;
  height: 35px;
  line-height: 35px;
  border: 2px solid #00abf0;
  text-indent: 37px;
  vertical-align: top;
  float: left;
}
input:focus {
  outline-offset: 0;
  outline: none;
}
.search-btn {
  background: #00abf0;
  width: 72px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.33px;
  text-align: center;
  float: left;
}
.h-l-wrapper {
  float: left;
}
.h-r-wrapper {
  float: right;
}
.h-r-wrapper .function-text {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.33px;
  margin-right: 35px;
  &:hover {
    color: #0ae;
  }
}
.h-r-wrapper .header-item:last-child .function-text {
  margin-right: 0;
  vertical-align: middle;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.h-r-wrapper .function-btn {
  background: #00abf0;
  width: 120px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.33px;
  text-align: center;
}
.nav-wrapper {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.nav-wrapper .nav-item {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.33px;
  margin: 13px 61px 13px 0;
}
.nav-wrapper .nav-item-active {
  color: #0ae;
  font-weight: bold;
}
.breadcrumb-wrapper {
  width: 1200px;
  margin: 0 auto 0 auto;
  padding: 8px 0;
  .h-breadcrumb > span:last-child {
    color: #3060ff;
  }
}
.fl {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/marketBar.vue